import React, { useEffect, useState, forwardRef } from "react";
import { useHistory } from "react-router-dom";

import clsx from "clsx";
import {
  Button,
  Form,
  OverlayTrigger,
  Popover,
  Tooltip,
} from "react-bootstrap";

import iconMalusRed from "../../../assets/images/icon-malus-red.png";
import iconMalus from "../../../assets/images/icon-malus.png";

import iconBonusGreen from "../../../assets/images/icon-bonus-green.png";
import iconBonus from "../../../assets/images/icon-bonus.png";

import iconAddBonusMalusColor from "../../../assets/images/add-bonus-malus-icon-color.png";

import iconMoinScore from "../../../assets/images/moin-score.png";
import iconPlusScore from "../../../assets/images/plus-score.png";

import ping from "../../../assets/images/ping.png";
import pingSelected from "../../../assets/images/ping-selected.png";
import pingHover from "../../../assets/images/ping-hover.png";

import "./addGrille.css";

const CriteriaOption = (props) => {
  const history = useHistory();

  const [isSelectionNeutre, setIsSelectionNeutre] = useState(false);
  const [isSelectionBonus, setIsSelectionBonus] = useState(false);
  const [isSelectionMalus, setIsSelectionMalus] = useState(false);
  const [bonusValue, setBonusValue] = useState(false);
  const [malusValue, setMalusValue] = useState(false);

  const [addedDetailsBonus, setAddedDetailsBonus] = useState(false);

  const [score, setScore] = useState(10);
  const [selectedPing, setSelectedPing] = useState(false);
  const [hoverPing, setHoverPing] = useState(false);

  const [criteriaOptions, setCriteriaOptions] = useState(props.groupeCritere?.filter((e) => e.idCriteriaGroup === props.idGroupCriteria)[0]?.Criteria.filter(((e) => e.idCriteria === props.idCriteria))[0]?.CriteriaOption);
  const [currentCriteriaOption, setCurrentCriteriaOption,] = useState(null);
  const [isFocused, setIsFocused] = useState(false);


  useEffect(() => {
    setCriteriaOptions(props.groupeCritere?.filter((e) => e.idCriteriaGroup === props.idGroupCriteria)[0]?.Criteria.filter(((e) => e.idCriteria === props.idCriteria))[0]?.CriteriaOption);
    if (props.groupeCritere?.filter((e) => e.idCriteriaGroup === props.idGroupCriteria)[0]?.Criteria.filter(((e) => e.idCriteria === props.idCriteria))[0]?.CriteriaOption.length > 0 && props.groupeCritere?.filter((e) => e.idCriteriaGroup === props.idGroupCriteria)[0]?.Criteria.filter(((e) => e.idCriteria === props.idCriteria))[0]?.CriteriaOption.filter((e) => e?.type === 'BONUS').length > 0 && props.groupeCritere?.filter((e) => e.idCriteriaGroup === props.idGroupCriteria)[0]?.Criteria.filter(((e) => e.idCriteria === props.idCriteria))[0]?.CriteriaOption.filter((e) => e?.type === 'MALUS').length > 0) {
      setIsSelectionBonus(true)
      setIsSelectionMalus(true)
      setBonusValue(true)
    }
    if (props.groupeCritere?.filter((e) => e.idCriteriaGroup === props.idGroupCriteria)[0]?.Criteria.filter(((e) => e.idCriteria === props.idCriteria))[0]?.CriteriaOption.length > 0 && props.groupeCritere?.filter((e) => e.idCriteriaGroup === props.idGroupCriteria)[0]?.Criteria.filter(((e) => e.idCriteria === props.idCriteria))[0]?.CriteriaOption.filter((e) => e?.type === 'MALUS').length > 0 && props.groupeCritere?.filter((e) => e.idCriteriaGroup === props.idGroupCriteria)[0]?.Criteria.filter(((e) => e.idCriteria === props.idCriteria))[0]?.CriteriaOption.filter((e) => e?.type === 'BONUS').length === 0) {
      setIsSelectionMalus(true)
      setMalusValue(true)
    }
    if (props.groupeCritere?.filter((e) => e.idCriteriaGroup === props.idGroupCriteria)[0]?.Criteria.filter(((e) => e.idCriteria === props.idCriteria))[0]?.CriteriaOption.length > 0 && props.groupeCritere?.filter((e) => e.idCriteriaGroup === props.idGroupCriteria)[0]?.Criteria.filter(((e) => e.idCriteria === props.idCriteria))[0]?.CriteriaOption.filter((e) => e?.type === 'BONUS').length > 0 && props.groupeCritere?.filter((e) => e.idCriteriaGroup === props.idGroupCriteria)[0]?.Criteria.filter(((e) => e.idCriteria === props.idCriteria))[0]?.CriteriaOption.filter((e) => e?.type === 'MALUS').length === 0) {
      setIsSelectionBonus(true)
      setBonusValue(true)
    }
  }, []);

  const clickNeutre = () => {
    setIsSelectionNeutre(true)
    setIsSelectionBonus(false)
    setIsSelectionMalus(false)

    setBonusValue(false)
    setMalusValue(false)

    let dataN = {
      idCriteriaOption: 1,
      name: null,
      type: "NEUTRE",
      score: null
    }
    setCriteriaOptions([dataN])
    // props.groupeCritere?.filter((e) => e.idCriteriaGroup === props.idGroupCriteria)[0]?.Criteria.filter(((e) => e.idCriteria === props.idCriteria))[0]?.CriteriaOption = dataN
    props.handelChangeCriteriaOption(dataN, props.idGroupCriteria, props.idCriteria)
  };

  const clickBonus = () => {
    setIsSelectionNeutre(false)
    setIsSelectionBonus(true)
    setBonusValue(true)
    setMalusValue(false)

    setCriteriaOptions(criteriaOptions.filter((e) => e.type !== 'NEUTRE'))
  };

  const clickMalus = () => {
    setIsSelectionNeutre(false)
    setIsSelectionMalus(true)
    setMalusValue(true)
    setBonusValue(false)

    setCriteriaOptions(criteriaOptions.filter((e) => e.type !== 'NEUTRE'))
  };


  const addBonusOption = () => {
    const data = {
      idCriteriaOption: criteriaOptions.length + 1,
      name:`` ,
      type: "BONUS",
      score: 0
    };
    setCriteriaOptions([...criteriaOptions, data]);
    props.handelChangeCriteriaOption(data, props.idGroupCriteria, props.idCriteria)
  };

  const handleBonusOptionName = (value, idCriteriaOption) => {
    criteriaOptions.filter((e) => e.idCriteriaOption === idCriteriaOption)[0].name = value;
    criteriaOptions.filter((e) => e.idCriteriaOption === idCriteriaOption)[0].type = 'BONUS';
    setCriteriaOptions(criteriaOptions);
    props.handelChangeCriteriaOptionName(value, props.idGroupCriteria, props.idCriteria, idCriteriaOption)

  }
  const handleBonusOptionScore = (value, idCriteriaOption) => {
    criteriaOptions.filter((e) => e.idCriteriaOption === idCriteriaOption)[0].score = value;
    criteriaOptions.filter((e) => e.idCriteriaOption === idCriteriaOption)[0].type = 'BONUS';
    setCriteriaOptions(criteriaOptions);
    props.handelChangeCriteriaOptionScore(value, props.idGroupCriteria, props.idCriteria, idCriteriaOption)

  }
  const handleMalusOptionName = (value, idCriteriaOption) => {
    criteriaOptions.filter((e) => e.idCriteriaOption === idCriteriaOption)[0].name = value;
    criteriaOptions.filter((e) => e.idCriteriaOption === idCriteriaOption)[0].type = 'MALUS';
    setCriteriaOptions(criteriaOptions);
    props.handelChangeCriteriaOptionName(value, props.idGroupCriteria, props.idCriteria, idCriteriaOption)
  }
  const handleMalusOptionScore = (value, idCriteriaOption) => {
    criteriaOptions.filter((e) => e.idCriteriaOption === idCriteriaOption)[0].score = value;
    criteriaOptions.filter((e) => e.idCriteriaOption === idCriteriaOption)[0].type = 'MALUS';
    setCriteriaOptions(criteriaOptions);
    props.handelChangeCriteriaOptionScore(value, props.idGroupCriteria, props.idCriteria, idCriteriaOption)
  }

  const addMalusOption = () => {
    const data = {
      idCriteriaOption: criteriaOptions.length + 1,
      name: ``,
      type: "MALUS",
      score: 0
    };
    setCriteriaOptions([...criteriaOptions, data]);
    props.handelChangeCriteriaOption(data, props.idGroupCriteria, props.idCriteria)
  };

  return (
    <>
      <div
        className="section-bonus-malus"
        style={{
          height: isSelectionBonus || isSelectionMalus ? "fit-content" : "auto",
        }}
      >

        <div className="d-flex align-items-center justify-content-around ">
          <div
            className="bonus-malus-container d-flex align-items-center justify-content-center"
            onClick={() => {
              clickNeutre();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 25 25"
            >
              <g id="noun-blocked-1745761" transform="translate(-98 -28)">
                <path
                  style={{ fill: isSelectionNeutre || (!isSelectionBonus && !isSelectionMalus) ? "#5800E2" : "#B7B7B7" }}
                  id="Tracé_14878"
                  data-name="Tracé 14878"
                  d="M110.5,28A12.506,12.506,0,0,0,99.71,46.819a.837.837,0,1,0,1.441-.851,10.83,10.83,0,0,1,14.818-14.818.837.837,0,1,0,.851-1.441A12.472,12.472,0,0,0,110.5,28Zm8.134,3.5a.834.834,0,0,0-.573.252L101.75,48.069a.835.835,0,1,0,1.18,1.18L119.242,32.93a.833.833,0,0,0-.608-1.432Zm1.892,2.266a.833.833,0,0,0-.677,1.267,10.83,10.83,0,0,1-14.818,14.818.837.837,0,1,0-.851,1.441A12.507,12.507,0,0,0,121.29,34.181a.833.833,0,0,0-.764-.417Z"
                  transform="translate(0 0)"
                  fill="#b7b7b7"
                />
              </g>
            </svg>
            <div
              style={{
                fontFamily: "Gilroy",
                fontSize: 16,
                color: isSelectionNeutre || (!isSelectionBonus && !isSelectionMalus) ? "#5800E2" : "#B7B7B7",
              }}
            >
              Neutre
            </div>
          </div>

          <div
            className="bonus-malus-container d-flex align-items-center justify-content-center"
            style={{
              backgroundColor: isSelectionBonus
                ? "rgba(28, 169, 27, 0.1)"
                : "#FAFAFA",
            }}
            onClick={() => {
              clickBonus();
            }}
          >
            <img src={isSelectionBonus ? iconBonusGreen : iconBonus} />
            <div
              style={{
                fontFamily: "Gilroy",
                fontSize: 16,
                color: isSelectionBonus ? "rgb(28, 169, 27)" : "#B7B7B7",
              }}
            >
              Bonus
            </div>
          </div>

          <div
            className="bonus-malus-container d-flex align-items-center justify-content-center"
            style={{
              backgroundColor: isSelectionMalus ? "#FCE5E5" : "#FAFAFA",
            }}
            onClick={() => {
              clickMalus();
            }}
          >
            <img src={isSelectionMalus ? iconMalusRed : iconMalus} />
            <div
              style={{
                fontFamily: "Gilroy",
                fontSize: 16,
                color: isSelectionMalus ? "#E30707" : "#B7B7B7",
              }}
            >
              Malus
            </div>
          </div>
        </div>

        {isSelectionMalus || isSelectionBonus ? (
          <div>
            <hr />
            <div
              className={clsx(
                { "d-flex ": true },
                { "align-items-center": !addedDetailsBonus },
                { "align-items-baseline": addedDetailsBonus }
              )}
              style={{ gap: '10px' }}
            >

              {
                bonusValue ?

                  criteriaOptions.length > 0 ? criteriaOptions.filter((e) => e.type === 'BONUS').map((val, i) => (
                    <div
                      style={{ height: (addedDetailsBonus && currentCriteriaOption === val.idCriteriaOption) ? "fit-content" : "40px" }}
                      className={`${val.name === ''&&props.isEmptyBonusValue? 'container-bonus-malus-erreur' : 'container-bonus-malus'}`}
                    >
                      <label className="labelBM" onClick={() => { setAddedDetailsBonus(!addedDetailsBonus); setCurrentCriteriaOption(val.idCriteriaOption) }}>
                        <input
                          type="text"
                          style={{ height: 30 }}
                          maxLength="64"
                          placeholder={`Ajout ${bonusValue ? 'bonus' : 'malus'}`}
                          onChange={(e) => { handleBonusOptionName(e.target.value, val.idCriteriaOption) }}
                          defaultValue={val.name}
                          className="border-bonus"
                        />
                        <svg
                          className="icon"

                          style={{
                            transform: (addedDetailsBonus && currentCriteriaOption === val.idCriteriaOption) ? "rotate(45deg)" : null,
                            marginTop: (addedDetailsBonus && currentCriteriaOption === val.idCriteriaOption) ? "-7px" : null,
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20.5"
                          height="20.5"
                          viewBox="0 0 20.5 20.5"
                        >
                          <path
                            style={{
                              fill: (addedDetailsBonus && currentCriteriaOption === val.idCriteriaOption) ? "#5800E2" : "#B7B7B7",
                            }}
                            id="Tracé_14875"
                            data-name="Tracé 14875"
                            d="M12,7a1,1,0,0,0-1,1v3H8a1,1,0,0,0,0,2h3v3a1,1,0,0,0,2,0V13h3a1,1,0,0,0,0-2H13V8A1,1,0,0,0,12,7Zm0-5A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.011,8.011,0,0,1,12,20Z"
                            transform="translate(-1.75 -1.75)"
                            fill="#b7b7b7"
                            stroke="#fff"
                            strokeWidth="0.5"
                          />
                        </svg>
                      </label>
                      {(addedDetailsBonus && currentCriteriaOption === val.idCriteriaOption) ? (
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ gap: 10 }}
                        >
                          <div className="score-bonus-malus-edit">
                            <img
                              src={iconMoinScore}
                              onClick={() => { setScore(val?.score <= 0 ? 0 : val?.score - 10); handleBonusOptionScore(val?.score <= 0 ? 0 : val?.score - 10, val.idCriteriaOption) }}
                            />
                            <div> {val?.score} </div>
                            <img
                              src={iconPlusScore}
                              onClick={() => { setScore(val?.score >= 100 ? 100 : val?.score + 10); handleBonusOptionScore(val?.score >= 100 ? 100 : val?.score + 10, val.idCriteriaOption) }}
                            />
                          </div>

                          <div
                            style={{ cursor: "pointer" }}
                            onMouseEnter={() => setHoverPing(true)}
                            onMouseLeave={() => setHoverPing(false)}
                          >
                            {hoverPing && !selectedPing ? (
                              <OverlayTrigger
                                key="bottom"
                                placement="bottom"
                                overlay={
                                  <Tooltip
                                    data-color="#5800e2"
                                    className="critere"
                                    id={`tooltip-bottom`}
                                  >
                                    Appliquer par tous
                                  </Tooltip>
                                }
                              >
                                <img
                                  src={pingHover}
                                  height={30}
                                  onClick={() => {
                                    setSelectedPing(!selectedPing);
                                  }}
                                />
                              </OverlayTrigger>
                            ) : (
                              <div>
                                {selectedPing ? (
                                  <img
                                    src={pingSelected}

                                    height={30}
                                    onClick={() => {
                                      setSelectedPing(!selectedPing);
                                    }}
                                  />
                                ) : (
                                  <img src={ping} height={30} />
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ))

                    : null
                  : null
              }


              {
                malusValue ?

                  criteriaOptions.length > 0 ? criteriaOptions.filter((e) => e.type === 'MALUS').map((val, i) => (
                    <div
                      style={{ height: (addedDetailsBonus && currentCriteriaOption === val.idCriteriaOption) ? "fit-content" : "40px" }}
                      className='container-bonus-malus'
                    >
                      <label className="labelBM " onClick={() => { setAddedDetailsBonus(!addedDetailsBonus); setCurrentCriteriaOption(val.idCriteriaOption) }}>
                        <input
                          type="text"
                          style={{ height: 30 }}
                          maxLength="64"
                          placeholder={`Ajout ${bonusValue ? 'bonus' : 'malus'}`}
                          onChange={(e) => { handleMalusOptionName(e.target.value, val.idCriteriaOption) }}
                          defaultValue={val.name}
                          className="border-bonus"
                        />
                        <svg
                          className="icon"
                          style={{
                            transform: (addedDetailsBonus && currentCriteriaOption === val.idCriteriaOption) ? "rotate(45deg)" : null,
                            marginTop: (addedDetailsBonus && currentCriteriaOption === val.idCriteriaOption) ? "-7px" : null,
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20.5"
                          height="20.5"
                          viewBox="0 0 20.5 20.5"
                        >
                          <path
                            style={{
                              fill: (addedDetailsBonus && currentCriteriaOption === val.idCriteriaOption) ? "#5800E2" : "#B7B7B7",
                            }}
                            id="Tracé_14875"
                            data-name="Tracé 14875"
                            d="M12,7a1,1,0,0,0-1,1v3H8a1,1,0,0,0,0,2h3v3a1,1,0,0,0,2,0V13h3a1,1,0,0,0,0-2H13V8A1,1,0,0,0,12,7Zm0-5A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.011,8.011,0,0,1,12,20Z"
                            transform="translate(-1.75 -1.75)"
                            fill="#b7b7b7"
                            stroke="#fff"
                            strokeWidth="0.5"
                          />
                        </svg>
                      </label>
                      {(addedDetailsBonus && currentCriteriaOption === val.idCriteriaOption) ? (
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ gap: 10 }}
                        >
                          <div className="score-bonus-malus-edit">
                            <img
                              src={iconMoinScore}
                              onClick={() => { setScore(val?.score <= 0 ? 0 : val?.score - 10); handleMalusOptionScore(val?.score <= 0 ? 0 : val?.score - 10, val.idCriteriaOption) }}
                            />
                            <div> {val?.score} </div>
                            <img
                              src={iconPlusScore}
                              onClick={() => { setScore(val?.score >= 100 ? 100 : val?.score + 10); handleMalusOptionScore(val?.score >= 100 ? 100 : val?.score + 10, val.idCriteriaOption) }}
                            />
                          </div>

                          <div
                            style={{ cursor: "pointer" }}
                            onMouseEnter={() => setHoverPing(true)}
                            onMouseLeave={() => setHoverPing(false)}
                          >
                            {hoverPing && !selectedPing ? (
                              <OverlayTrigger
                                key="bottom"
                                placement="bottom"
                                overlay={
                                  <Tooltip
                                    data-color="#5800e2"
                                    className="critere"
                                    id={`tooltip-bottom`}
                                  >
                                    Appliquer par tous
                                  </Tooltip>
                                }
                              >
                                <img
                                  src={pingHover}
                                  height={30}
                                  onClick={() => {
                                    setSelectedPing(!selectedPing);
                                  }}
                                />
                              </OverlayTrigger>
                            ) : (
                              <div>
                                {selectedPing ? (
                                  <img
                                    src={pingSelected}

                                    height={30}
                                    onClick={() => {
                                      setSelectedPing(!selectedPing);
                                    }}
                                  />
                                ) : (
                                  <img src={ping} height={30} />
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ))

                    : null
                  : null
              }

              <div className="add-container" onClick={bonusValue ? addBonusOption : addMalusOption}>
                <img src={iconAddBonusMalusColor} />
              </div>
            </div>

          </div>
        ) : null}
      </div>
    </>
  );
};

export default CriteriaOption;
